import { render } from "./AvatarUploader.vue?vue&type=template&id=20e87e03&scoped=true&ts=true"
import script from "./AvatarUploader.vue?vue&type=script&lang=ts"
export * from "./AvatarUploader.vue?vue&type=script&lang=ts"

import "./AvatarUploader.vue?vue&type=style&index=0&id=20e87e03&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e87e03"]])

export default __exports__